import React from 'react';
import { Map } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * RoadmapCardWidget - Hub navigation card for project roadmaps
 *
 * Shows progress across ALL phase-tagged tasks (any project).
 * Navigates to the RoadmapView on click.
 */
export default function RoadmapCardWidget({ onNavigate, tasks = [] }) {
  const roadmapTasks = tasks.filter(t => t.project && t.phase);
  const doneCount = roadmapTasks.filter(t => t.done).length;

  // Only show if any project has phase-tagged tasks
  if (roadmapTasks.length === 0) return null;

  return (
    <button
      onClick={() => onNavigate && onNavigate('roadmap')}
      style={{
        width: '100%',
        padding: '16px 12px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '6px',
        transition: 'all 0.15s ease'
      }}
    >
      <Map size={24} color="#534AB7" />
      <span style={{
        fontSize: '13px',
        fontWeight: '600',
        color: ABLE_COLORS.textPrimary
      }}>
        Roadmap
      </span>
      <span style={{
        fontSize: '10px',
        color: ABLE_COLORS.textMuted
      }}>
        {roadmapTasks.length > 0 ? `${doneCount}/${roadmapTasks.length} done` : 'Launch tracker'}
      </span>
    </button>
  );
}
